import keepAlive from "../../util/keepAlive";

const fundDetail = [{
    path: "/publicFundsDetail",
    name: "产品详情",
    // component: () => import("@views/publicFunds/detail.vue"),
    component: () => import("@views/publicFunds/publicDetail.vue"),
    meta: {
      title: "公募基金详情",
      showBg: true,
      keepAlive: true,
      singleHead: true
    },
  },
  {
    path: "/publicFundsShareDetail",
    name: "产品详情",
    component: () => import("@views/publicFunds/publicShareDetail.vue"),
    meta: {
      title: "公募基金详情",
      showBg: true,
      keepAlive: true,
      singleHead: true
    },
  },
  {
    path: "/newFundShareDetail",
    name: "产品详情",
    component: () => import("@views/publicFunds/newFundShareDetail.vue"),
    meta: {
      title: "新发基金详情",
      showBg: true,
      keepAlive: true,
      singleHead: true
    },
  },
  {
    path: "/newFundDetail",
    name: "产品详情",//新发基金
    component: () => import("@views/publicFunds/newFundDetail.vue"),
    meta: {
      title: "公募基金详情",
      showBg: true,
      keepAlive:true
    },
  },
  {
    path: "/annular",
    name: "净值走势",
    component: () => import("@views/publicFunds/annular/index.vue"),
    meta: {
      title: "净值走势",
    },
  },
  {
    path: "/tradingRules",
    name: "交易规则",
    component: () => import("@views/publicFunds/tradingRules/index.vue"),
    meta: {
      title: "交易规则",
    },
  },
  {
    path: "/fundFiles",
    name: "基金档案",
    component: () => import("@views/publicFunds/fundFiles/index.vue"),
    meta: {
      title: "基金档案",
      keepAlive: true,
    },
  },
  {
    path: "/noticDetail",
    name: "公告详情",
    component: () => import("@views/publicFunds/fundFiles/pubicNotice/detail.vue"),
    meta: {
      title: "公告详情",
    },
  },
  {
    path: "/fundManger",
    name: "基金经理",
    component: () => import("@views/publicFunds/fundFiles/fundManager/index.vue"),
    meta: {
      title: "基金经理",
    },
  },
  // {
  //   path: "/fixedZone",
  //   name: "定投专区",
  //   component: () => import("@views/publicFunds/fixedZone/fixedZone"),
  //   meta: {
  //     title: "定投专区",
  //   },
  // },
  // {
  //   path: "/managerDetail",
  //   name: "基金经理",
  //   component: () => import("@views/publicFunds/fundFiles/fundManager/detail.vue"),
  //   meta: {
  //     title: "基金经理",
  //   },
  // },
  {
    path: "/publicSurvival",
    name: "公募存续",
    component: () => import("@/views/assets/detail/publicAssetItem/index.vue"),
    meta: {
      title: "",
      singleHead:true,
      keepAlive:true,
    },
  },
  {
    path: "/survivalDetail",
    name: "存续详情",
    component: () => import("@views/publicFunds/survivalDetail.vue"),
    // beforeEnter: (to, from, next) => {
    //   if(from.path == "/publicSurvival") {
    //     to.meta.keepAlive = false; // 关闭缓存
    //     next();
    //   }else{
    //     to.meta.keepAlive = true; // 打开缓存
    //     next();
    //   }
    // },
    meta: {
      title: "存续详情",
      showDetail: true,
      keepAlive:true,
      useCatch: false //是否用缓存
    },
  },
  {
    path: "/modifyDividendWay",
    name: "修改分红方式",
    component: () => import("@views/publicFunds/modifyDividendWay.vue"),
    meta: {
      title: "修改分红方式",
    },
  },
  {
    path: "/dividendDetail",
    name: "现金分红详情",
    component: () => import("@views/publicFunds/dividendDetail.vue"),
    meta: {
      title: "现金分红详情",
      singleHead:true
    },
  },
  {
    path: "/dividendList",
    name: "操作记录",
    component: () => import("@views/publicFunds/dividendList.vue"),
    meta: {
      title: "操作记录",
    },
  },
  {
    path: "/investmentHistory",
    name: "历史投资",
    component: () => import("@views/publicFunds/historyTabInv.vue"),
    meta: {
      title: "公募历史投资"
    },
  },
  {
    path: "/nativeHistoryPage",
    name: "历史投资",
    component: () => import("@views/publicFunds/historyTabInv.vue"),
    meta: {
      title: "原生主页历史投资"
    },
  },
  {
    path: "/investmentRe",
    name: "投资检视",
    component: () => import("@views/publicFunds/investmentRe.vue"),
    meta: {
      title: "公募基金",
      showScreening: true,
      keepAlive: true
    },
  },
  {
    path: "/shareDetail",
    name: "份额明细",
    component: () => import("@views/publicFunds/shareDetail.vue"),
    meta: {
      title: "份额明细"
    },
  },
  {
    path: "/orderDetail",
    name: "订单详情",
    component: () => import("@views/publicFunds/orderDetail.vue"),
    meta: {
      title: "公募基金"
    },
  },
  {
    path: "/privateSurvival",
    name: "私募证券",
    // component: () => import("@views/publicFunds/privateSurvival.vue"),
    component:()=>import("@views/assets/detail/privateAssetItem/index.vue"),
    meta: {
      title: "我的资产",
      // showBg: true,
      keepAlive:true,
      // repeatName:true,
      singleHead:true,
    },
  },
  {
    path: "/productReport",
    name: "产品报告",
    component: () => import("@views/publicFunds/productReport.vue"),
    meta: {
      title: "公募基金",
      singleHead: true
    },
  },
  {
    path: "/productNotice",
    name: "产品公告",
    component: () => import("@views/publicFunds/productNotice.vue"),
    meta: {
      title: "公募基金",
      singleHead: true
    },
  },
  {
    path: "/infoDisclosure",
    name: "我的信披",
    component: () => import("@views/publicFunds/infoDisclosure.vue"),
    meta: {
      title: "公募基金",
      keepAlive:true,
      singleHead: true
    },
  },
  {
    path: "/infoDisclosureDetail",
    name: "我的信披",
    component: () => import("@views/publicFunds/infoDisclosureDetail.vue"),
    meta: {
      title: "公募基金",
      singleName:true,
    },
  },
  {
    path: "/disclosureNative",
    name: "我的信披",
    component: () => import("@views/publicFunds/infoDisclosure.vue"),
    meta: {
      title: "公募基金",
      keepAlive:true,
      singleHead: true
    },
  },
  {
    path: "/historyInvestment",
    name: "历史投资",
    component: () => import("@views/publicFunds/historyInvestment.vue"),
    meta: {
      title: "私募存续"
    },
  },
  {
    path: "/secondSurvival",
    name: "存续详情",
    component: () => import("@views/publicFunds/secondSurvival.vue"),
    // component: () => import("@views/assets/detail/privateAssetItem/detail.vue"),
    meta: {
      title: "私募二级市场存续详情",
      keepAlive: true
    },
  },
  {
    path: "/aboutDoc",
    name: "相关文件",
    component: () => import("@views/publicFunds/aboutDoc.vue"),
    meta: {
      title: "私募二级市场存续详情",
      sendEmail:true
    },
  },
  {
    path: "/privateInvestment",
    name: "历史投资",
    component: () => import("@views/publicFunds/historyInv.vue"),
    meta: {
      title: "私募历史投资",
    },
  },
  {
    path: "/privateSurvivalO",
    name: "存续详情",
    component: () => import("@views/publicFunds/privateSurvivalO.vue"),
    meta: {
      title: "私募股权地产存续详情"
    },
  },
  {
    path: "/moreHistoryData",
    name: "历史净值",
    component: () => import("@views/publicFunds/moreHistoryData.vue"),
    meta: {
      title: "历史净值"
    },
  },
  {
    path: "/moreAnnualData",
    name: "历史七日年化",
    component: () => import("@views/publicFunds/moreAnnualData.vue"),
    meta: {
      title: "历史七日年化"
    },
  },
  {
    path: "/historyNetValue",
    name: "历史净值",
    component: () => import("@views/publicFunds/historyNetValue.vue"),
    meta: {
      title: "私募存续"
    },
  },
  {
    path: "/historyAnnualAllData",
    name: "历史七日年化",
    component: () => import("@views/publicFunds/historyAnnualAllData.vue"),
    meta: {
      title: "私募存续"
    },
  },
  {
    path: "/pubicNoticeDetail",
    name: "公告详情",
    component: () => import("@views/publicFunds/fundFiles/pubicNotice/detail.vue"),
    meta: {
      title: "公募公告"
    },
  },
  {
    path: "/moreRankData",
    name: "历史业绩",
    component: () => import("@views/publicFunds/moreRankData.vue"),
    meta: {
      title: "历史业绩"
    },
  }, 
  {
    path: "/productInvestStrategy",
    name: "投资策略",
    component: () => import("@views/private/masterMarket/investmentStrategy.vue"),
    meta: {
      title: "投资策略",
      singleHead:true,
    },
  },
  {
    path: "/productScale",
    name: "产品规模",
    component: () => import("@views/private/detailComponent/productScale.vue"),
    meta: {
      title: "产品规模"
    },
  },
]
export default fundDetail